import { PHONE_RUNTIME_LATEST, type ValidateCaseBundleOptions, type ValidationResult } from '@peekie/case-spec'
import {
  PAYPAL_INCOMING_RUNTIME,
  VALIDATOR_ID,
  validateAgainstSchema,
} from './schema'

/** Frozen 0.1 / 0.2 pins. Dash-only; phone Studio pins live in @peekie/case-spec. */
export const DASH_PHONE_VERSION_VALIDATORS: Record<string, string> = {
  '0.1.0': VALIDATOR_ID,
  '0.1.1': VALIDATOR_ID,
  '0.1.2': VALIDATOR_ID,
  '0.1.3': VALIDATOR_ID,
  '0.1.4': VALIDATOR_ID,
  '0.1.5': VALIDATOR_ID,
  '0.1.6': VALIDATOR_ID,
  '0.1.7': VALIDATOR_ID,
  '0.1.8': VALIDATOR_ID,
  '0.1.9': VALIDATOR_ID,
  '0.2.0': VALIDATOR_ID,
  '0.2.1': VALIDATOR_ID,
  '0.2.2': VALIDATOR_ID,
  '0.2.3': VALIDATOR_ID,
  '0.2.4': VALIDATOR_ID,
  '0.2.5': VALIDATOR_ID,
  '0.2.6': VALIDATOR_ID,
  '0.2.7': VALIDATOR_ID,
  '0.2.8': VALIDATOR_ID,
  '0.2.9': VALIDATOR_ID,
  '0.2.10': VALIDATOR_ID,
  '0.2.11': VALIDATOR_ID,
  '0.2.13': VALIDATOR_ID,
  '0.2.14': VALIDATOR_ID,
  '0.2.15': VALIDATOR_ID,
  '0.2.16': VALIDATOR_ID,
  '0.2.17': VALIDATOR_ID,
  '0.2.18': VALIDATOR_ID,
  '0.2.19': VALIDATOR_ID,
  '0.2.20': VALIDATOR_ID,
  '0.2.21': VALIDATOR_ID,
  '0.2.22': VALIDATOR_ID,
  '0.2.23': VALIDATOR_ID,
  '0.2.24': VALIDATOR_ID,
  '0.2.25': VALIDATOR_ID,
  '0.2.26': VALIDATOR_ID,
  '0.2.27': VALIDATOR_ID,
  '0.2.28': VALIDATOR_ID,
  '0.2.29': VALIDATOR_ID,
  '0.2.30': VALIDATOR_ID,
  '0.2.31': VALIDATOR_ID,
  '0.2.32': VALIDATOR_ID,
  '0.2.33': VALIDATOR_ID,
  '0.2.34': VALIDATOR_ID,
  '0.2.35': VALIDATOR_ID,
  '0.2.36': VALIDATOR_ID,
  '0.2.37': VALIDATOR_ID,
  '0.2.38': VALIDATOR_ID,
  '0.2.39': VALIDATOR_ID,
  '0.2.40': VALIDATOR_ID,
  '0.2.41': VALIDATOR_ID,
  '0.2.42': VALIDATOR_ID,
  '0.2.43': VALIDATOR_ID,
  '0.2.44': VALIDATOR_ID,
  '0.2.45': VALIDATOR_ID,
  '0.2.46': VALIDATOR_ID,
  '0.2.47': VALIDATOR_ID,
  '0.2.48': VALIDATOR_ID,
  '0.2.49': VALIDATOR_ID,
  '0.2.50': VALIDATOR_ID,
  '0.2.51': VALIDATOR_ID,
  '0.2.52': VALIDATOR_ID,
  '0.2.53': VALIDATOR_ID,
  '0.2.54': VALIDATOR_ID,
  '0.2.55': VALIDATOR_ID,
  '0.2.56': VALIDATOR_ID,
  '0.2.57': VALIDATOR_ID,
  '0.2.58': VALIDATOR_ID,
  '0.2.59': VALIDATOR_ID,
  '0.2.60': VALIDATOR_ID,
  '0.2.61': VALIDATOR_ID,
  '0.2.62': VALIDATOR_ID,
  '0.2.63': VALIDATOR_ID,
  '0.2.64': VALIDATOR_ID,
  '0.2.65': VALIDATOR_ID,
  '0.2.66': VALIDATOR_ID,
  '0.2.68': VALIDATOR_ID,
  '0.2.69': VALIDATOR_ID,
  '0.2.70': VALIDATOR_ID,
  '0.2.71': VALIDATOR_ID,
  '0.2.72': VALIDATOR_ID,
  '0.2.73': VALIDATOR_ID,
  '0.2.74': VALIDATOR_ID,
  '0.2.75': VALIDATOR_ID,
  '0.2.76': VALIDATOR_ID,
  '0.2.77': VALIDATOR_ID,
  '0.2.78': VALIDATOR_ID,
  '0.2.79': VALIDATOR_ID,
  '0.2.80': VALIDATOR_ID,
  '0.2.81': VALIDATOR_ID,
  '0.2.82': VALIDATOR_ID,
  '0.2.83': VALIDATOR_ID,
  '0.2.84': VALIDATOR_ID,
  '0.2.85': VALIDATOR_ID,
  '0.2.86': VALIDATOR_ID,
  '0.2.87': VALIDATOR_ID,
  '0.2.88': VALIDATOR_ID,
  '0.2.89': VALIDATOR_ID,
  '0.2.90': VALIDATOR_ID,
  '0.2.91': VALIDATOR_ID,
  '0.2.92': VALIDATOR_ID,
  '0.2.93': VALIDATOR_ID,
  '0.2.94': VALIDATOR_ID,
  '0.2.95': VALIDATOR_ID,
  '0.2.96': VALIDATOR_ID,
  '0.2.97': VALIDATOR_ID,
  '0.2.98': VALIDATOR_ID,
  '0.2.99': VALIDATOR_ID,
  '0.2.100': VALIDATOR_ID,
  '0.2.101': VALIDATOR_ID,
  '0.2.102': VALIDATOR_ID,
  '0.2.103': VALIDATOR_ID,
  '0.2.104': VALIDATOR_ID,
  '0.2.105': VALIDATOR_ID,
}

export const FREEZE_0_2 = '0.2.105'
export const DEFAULT_DASH_PHONE_VERSION = FREEZE_0_2

function compareSemver(a: string, b: string): number {
  const pa = a.split('.').map((n) => Number(n) || 0)
  const pb = b.split('.').map((n) => Number(n) || 0)
  for (let i = 0; i < 3; i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0)
    if (d !== 0) return d
  }
  return 0
}

export function listDashPhoneVersions(): string[] {
  return Object.keys(DASH_PHONE_VERSION_VALIDATORS).sort(compareSemver)
}

/** Alias used by dash call sites that previously read the shared pin map. */
export function listKnownPhoneVersions(): string[] {
  return listDashPhoneVersions()
}

export function isDashPhoneVersion(version: string): boolean {
  return version in DASH_PHONE_VERSION_VALIDATORS
}

export function isKnownPhoneVersion(version: string): boolean {
  return isDashPhoneVersion(version)
}

export function isDashPhoneRuntimePin(value: string): boolean {
  return value === PHONE_RUNTIME_LATEST || isDashPhoneVersion(value)
}

export function isPhoneRuntimePin(value: string): boolean {
  return isDashPhoneRuntimePin(value)
}

export function resolveValidatorId(phoneVersion: string): string {
  const id = DASH_PHONE_VERSION_VALIDATORS[phoneVersion]
  if (!id) {
    throw new Error(
      `Unknown dash phone version "${phoneVersion}". Known: ${listDashPhoneVersions().join(', ')}`,
    )
  }
  return id
}

/** Validate a dash locale package against the frozen 0.2 schema.jsonc. */
export function validateCaseBundle(
  input: unknown,
  options?: ValidateCaseBundleOptions | string,
): ValidationResult {
  const phoneVersion =
    typeof options === 'string'
      ? options
      : (options?.phoneVersion ?? DEFAULT_DASH_PHONE_VERSION)

  const validatorId = resolveValidatorId(phoneVersion)
  const result = validateAgainstSchema(input, {
    isPhoneRuntimePin: isDashPhoneRuntimePin,
    supportsPayPalIncoming:
      phoneVersion.startsWith('0.2.') &&
      compareSemver(phoneVersion, PAYPAL_INCOMING_RUNTIME) >= 0,
  })
  return {
    ...result,
    phoneVersion,
    validatorId,
  }
}
